import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { selectRole } from '../RoleSelector/roleselector';
import { selectRoleMobile } from '../RoleSelectorMobile/roleselectormobile';
import { _$ } from '../util/domHelper';
import request from '../api';
import { miloAlert } from '../AlertDialog';
import { BindArea } from '@tencent/milo-core';
var areaBind = BindArea.bind.bind(BindArea);
var areaInit = BindArea.init.bind(BindArea);
var getAreaConfig = BindArea.getRoleInfoConfig.bind(BindArea); // console.log('test')

var AreaBindComp = /*#__PURE__*/function () {
  function AreaBindComp(option) {
    _classCallCheck(this, AreaBindComp);

    this.option = _objectSpread({
      plat: 'pc',
      queryOptions: {},
      bindOptions: {}
    }, option);
  }

  _createClass(AreaBindComp, [{
    key: "bind",
    value: function bind(roleInfo) {
      var _this = this;

      var self = this;
      var _this$option$bindOpti = this.option.bindOptions,
          onSuccess = _this$option$bindOpti.onSuccess,
          onFail = _this$option$bindOpti.onFail,
          _this$option$bindOpti2 = _this$option$bindOpti.flowConfig,
          flowConfig = _this$option$bindOpti2 === void 0 ? {} : _this$option$bindOpti2;

      if (roleInfo || flowConfig.roleInfo) {
        this.option.bindOptions.roleInfo = roleInfo || flowConfig.roleInfo;
        request(areaBind, this.option.bindOptions).then(function (_ref) {
          var bindInfo = _ref.bindInfo;
          console.log(bindInfo);
          self.renderBindInfo(bindInfo);

          if (bindInfo.iRet === '102') {
            // 102 您已成功绑定过大区信息，不能修改或者重复绑定
            if (onFail) {
              onFail(bindInfo);
            } else {
              miloAlert(bindInfo.sMsg || bindInfo.errMsg || bindInfo.msg || '当前网络繁忙,请稍后重试');
            }
          } else {
            onSuccess && onSuccess(bindInfo);
          }
        })["catch"](function (err) {
          console.log(err);

          if (err.errCode && parseInt(err.errCode) === -1) {
            // 登陆错误统一处理
            return;
          }

          if (onFail) {
            onFail(err);
          } else {
            miloAlert(err.sMsg || err.errMsg || err.msg || '当前网络繁忙,请稍后重试');
          }
        });
      } else {
        request(getAreaConfig, this.option.bindOptions).then(function (config) {
          console.log('rs param', config);
          var gameId = config.gameId,
              sRoleInfoUrl = config.sRoleInfoUrl,
              openToOpen = config.openToOpen;

          var rsOption = _objectSpread({
            type: 'float',
            charset: 'utf8',
            gameId: gameId,
            sRoleInfoUrl: sRoleInfoUrl,
            openToOpen: openToOpen
          }, config);

          console.log(selectRole);
          var selectRoleFun = _this.option.plat == 'mobile' ? selectRoleMobile : selectRole;
          selectRoleFun(_objectSpread(_objectSpread({}, rsOption), {}, {
            onSubmit: function onSubmit(roleInfo) {
              self.bind(roleInfo);
            }
          }));
        })["catch"](function (err) {
          console.log(err);

          if (err.errCode && parseInt(err.errCode) === -1) {
            // 登陆错误统一处理
            return;
          }

          if (onFail) {
            onFail(err);
          } else {
            miloAlert(err.sMsg || err.errMsg || err.msg || '当前网络繁忙,请稍后重试');
          }
        });
      }
    }
  }, {
    key: "query",
    value: function query() {
      var self = this;

      var _ref2 = this.option.queryOptions || {},
          onSuccess = _ref2.onSuccess,
          onFail = _ref2.onFail;

      request(areaInit, this.option.queryOptions).then(function (_ref3) {
        var option = _ref3.option,
            bindInfo = _ref3.bindInfo;
        console.log(option);
        self.renderBindInfo(bindInfo);
        onSuccess && onSuccess(bindInfo);
      })["catch"](function (err) {
        self.renderNotBind(err);
        console.log(err);

        if (err.errCode && parseInt(err.errCode) === -1) {
          // 登陆错误统一处理
          return;
        }

        if (onFail) {
          onFail(err);
        } else {
          miloAlert(err.errMsg || err.sMsg || err.msg || '当前网络繁忙,请稍后重试');
        }
      });
    }
    /*
      * 显示绑定大区
      */

  }, {
    key: "renderBindInfo",
    value: function renderBindInfo(retObj) {
      var iFlowId = this.option.queryOptions.iFlowId;

      if (_$("spanNotBind_".concat(iFlowId))) {
        _$("spanNotBind_".concat(iFlowId)).style.display = 'none';
      }

      if (_$("spanBind_".concat(iFlowId))) {
        _$("spanBind_".concat(iFlowId)).style.display = '';
      }

      if (_$("area_info_".concat(iFlowId))) {
        if (retObj.jData.data && retObj.jData.data.FareaName) {
          _$("area_info_".concat(iFlowId)).innerHTML = decodeURIComponent(retObj.jData.data.FareaName);
        }

        if (retObj.jData.data && retObj.jData.data.FroleName) {
          _$("role_info_".concat(iFlowId)).innerHTML = decodeURIComponent(retObj.jData.data.FroleName);
        }
      }
    }
  }, {
    key: "renderNotBind",
    value: function renderNotBind() {
      var iFlowId = this.option.queryOptions.iFlowId; // 显示未绑定信息

      if (_$("spanNotBind_".concat(iFlowId))) {
        _$("spanNotBind_".concat(iFlowId)).style.display = '';
      }

      if (_$("spanBind_".concat(iFlowId))) {
        _$("spanBind_".concat(iFlowId)).style.display = 'none';
      }
    }
  }]);

  return AreaBindComp;
}(); // 入口


export { AreaBindComp as default };
export var AreaBind = {
  init: function init(option) {
    return new Promise(function (resolve, reject) {
      var instance;

      try {
        instance = new AreaBindComp(option);
        resolve(instance);
      } catch (e) {
        console.log(e);
        reject({
          errCode: -2,
          errMsg: '大区绑定模块初始化失败'
        });
      }
    });
  }
};
export var bindArea = function bindArea(option) {
  var areabind = new AreaBindComp(option);
  areabind.bind();
};